import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {setupInit} from './../SetupLoader/setupLoaderActions';
import {hideBlockedChatPopup} from './../Editions/editionsActions';

import Layout from './../../hoc/Layout/Layout';
import ArticlesListRenderer from './../ArticlesList/ArticlesListRenderer';
import EditionsSelector from './../Editions/Selector/EditionsSelector';
import {LoadingPage} from './../Loader/LoadingPage';

import Footer from './../../containers/Navigation/Footer/Footer';
import Header from './../../containers/Navigation/Header/Header';
import TinyJellyShape from './../../containers/UI/Common/JellyShape/TinyJellyShape';
import ClickableIcon from './../../containers/UI/ClickableIcon/ClickableIcon';
import ChatButton from './../UI/Common/ChatButton/ChatButton';
import DoubleHalfCircle from './../../containers/UI/Common/Shapes/DoubleHalfCircle';
import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';
import MessageModal from './../../containers/UI/MessageModal/MessageModal';

//-- formulaire
import MailInvitationForm from './../forms/mailInvitationForm';

//-- Utils
import {pushPageView} from '../../utils/tracking/customGtm';
import {pushHeaderTitle} from '../../utils/dom/helper';

// assets
import BurgerMenu from './../../assets/images/icons/burger.svg';
import Avatar from '../../containers/UI/Avatar/Avatar';
import Image from './../../containers/UI/Image/Image';
import SubscribeImg from '../../assets/images/subscribe.png';

// config
import * as config from './../../conf/config';
import Button from "../../containers/UI/Button/Button";

class HomePage extends Component {

    state = {
        containerWidth: 0,
        displayMode: 'MOBILE',
        showTryoutPopup: true
    }

    // properties used for managing bind event (global variable approach)
    timer = null;

    componentDidMount() {
        //-- Update title
        if (typeof this.props.currentEdition !== 'undefined' && this.props.currentEdition.name) {
            pushHeaderTitle(`Edition du ${this.props.currentEdition.name}`);

            //-- Push GTM page view
            pushPageView();
        }

        window.addEventListener('scroll', this.handleScroll);
        const {
            setup,
            dispatch
        } = this.props;
        if (setup.loadingStatus !== 2 || setup.setupError === true) {
            dispatch(setupInit());
        }

        this.handleResize();
        window.addEventListener('resize', this.handleResize)

    };

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    };

    componentDidUpdate(prevProps) {
        if (typeof this.props.currentEdition !== 'undefined' && this.props.currentEdition.name !== prevProps.currentEdition.name) {
            //-- Update title
            pushHeaderTitle(`Edition du ${this.props.currentEdition.name}`);

            //-- Push GTM page view
            pushPageView();
        }
    }

    handleScroll = (event) => {
        const top = document.documentElement.scrollTop || document.body.scrollTop;
        // const scrollHeight  = document.documentElement.scrollHeight || document.body.scrollHeight;
        const stickyHeader = document.querySelectorAll('.hp-header');
        //const stickyFooter = document.querySelectorAll('.hp-footer');

        let headerElement = Array.from(stickyHeader);
        // let footerElement = Array.from(stickyFooter)
        //[].forEach.call(stickyHeader, (el) => {
        headerElement.map(el => {
            if (top > 100) {
                el.classList.add('sticky');
            } else {
                el.classList.remove('sticky');
            }
            return el;
        });

        /* ticket #3291, remove sticky footer appearance/desappearance when scrolling
        footerElement.map(el => {
            if(!el.classList.contains("hiding")){
                el.classList.add('hiding');
            }

            if(top >0 && (top + window.innerHeight) <= scrollHeight){
                // tricks : reset timer that will be executed only when there is no more scroll event triggered
                clearTimeout( this.timer );

                this.timer = setTimeout(function() {
                    el.classList.remove('hiding');
                }, 500);

            }

        });*/

    };

    handleResize = () => {
        let currentWidth = window.innerWidth;
        let displayMode = '';
        if (config.responsiveBreakpointConfig) {
            for (let i = 0; i < config.responsiveBreakpointConfig.length; i++) {
                const breakPoints = config.responsiveBreakpointConfig[i];
                if (breakPoints.hasOwnProperty('maxWidth')) {
                    if (currentWidth <= breakPoints.maxWidth) {
                        displayMode = breakPoints.profile.toUpperCase();
                        break;
                    }
                }
            }
        }
        this.setState({
            containerWidth: window.innerWidth,
            displayMode: displayMode
        });
    }

    handleAvatarClick = () => {
        const {
            dispatch
        } = this.props;
        dispatch(push('/account/profile'));
    }

    onClickSubscribeHandler = (event) => {
        event.preventDefault();
        window.open(config.linkSubscribe, '_blank');
    }

    closeModalHandler = () => {
        const {dispatch} = this.props;
        dispatch(hideBlockedChatPopup());
    }

    onCloseTryOutPopup = () => {
        this.setState({
            showTryoutPopup: false
        });
    }

    onClickGoToLogin = () => {
        const {dispatch} = this.props;
        dispatch(push('/login'));
    }

    render() {

        const {
            uid,
            user,
            points
        } = this.props;

        var tryoutPopup = null;
        if (!this.props.isUserSignedIn && this.state.showTryoutPopup) {
            tryoutPopup = (
                <div className="tryout-popup">
                    <div className="close-btn" onClick={this.onCloseTryOutPopup}></div>
                    <div className="logo"></div>
                    <div className="beware">Le site est réservé à nos abonnés</div>
                    <div className="title">Connecte-toi</div>
                    <div className="infos">Accède à tous nos contenus </div>

                    <Button
                        key='login'
                        name='login'
                        class='yellowBtn'
                        action={this.onClickGoToLogin}
                        disabled={false}>
                        Je me connecte
                    </Button>
                    <div className="blue-zigzag">
                        <Zigzag color="#49d1e5"/>
                    </div>
                    <div className="yellow-zigzag">
                        <Zigzag color="#ffde39"/>
                    </div>
                </div>
            )
        }

        //console.log(this.props);
        return (this.props.isLoading) ? <LoadingPage/> : (
            <Layout layoutClass="home-page">

                <Header classes={`hp-header${this.state.displayMode === 'DESKTOP' ? ' desk' : ''}`} hasWideLogo={this.state.displayMode === 'DESKTOP' ? 'true' : null} >
                    <div className="dual-half-circle">
                        <DoubleHalfCircle color1='#fff' color2='#fcea10' rotateAngle="5"/>
                    </div>
                    {this.props.isUserSignedIn && <EditionsSelector/>}
                    <TinyJellyShape color="#49d1e5"/>
                </Header>

                <main>
                    <MessageModal
                        show={this.props.showBlockedChatPopup}
                        closeModalHandler={this.closeModalHandler}
                        image="blocked-chat"
                        message="Il faut être abonné pour chatter avec les journalistes"
                        zigzagColor="#ffde39"
                        zigzagClass="blue-shape"
                    />
                    {tryoutPopup}
                    <div className={`edition${this.state.displayMode === 'DESKTOP' ? ' desk' : ''}`}>
                        <div className="spacer"></div>
                        <ArticlesListRenderer route={this.props.match}
                                              isGridDisplay={this.state.displayMode === 'DESKTOP' ? true : false}/>
                    </div>
                </main>
                <Footer classes='hp-footer'>
                    <ClickableIcon name="toggleMenu" class="icon-menu" iconPath={BurgerMenu}/>
                    <span>
                      {this.props.isUserSignedIn ?
                          <Avatar avatarName={user.avatar} userName={user.username} isEditable={false}
                                  imgClick={this.handleAvatarClick} badgeUser={points.totalPoints}/>
                          :
                          <div className={`avatar-container subscribe${this.state.showTryoutPopup ? ' hide' : ''}`}
                               onClick={this.onClickSubscribeHandler}>
                              <Image
                                  isResponsive='true'
                                  imgPath={SubscribeImg}
                                  imgName="discovery-avatar"
                              />
                          </div>
                      }
                    </span>
                    <ChatButton roomName={`${uid}_ask`} metaData={user.username} comment={false}/>
                </Footer>
            </Layout>
        )
    }
}

const mapStateToProps = state => {
    return {
        isLoading: state.article.articleRetrievalInProgress,
        user: state.user,
        points: state.points,
        uid: state.auth.uid,
        setup: state.setup,
        currentEdition: state.editions.current,
        showBlockedChatPopup: state.editions.showBlockedChatPopup,
        isUserSignedIn: state.auth.isUserSignedIn
    }
};

export default connect(mapStateToProps)(HomePage);


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js